import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBelow45FNOV: typeof valueTypeRenderers.chillCumulativeHoursBelow45FNOV = {
  label: () => unitConverter.chillCumulativeHoursBelow45FNOV().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativeHoursBelow45FNOV().title(),
      render: (n) => unitConverter.chillCumulativeHoursBelow45FNOV(n).valueAsString(),
    }),
}
